import { getPage } from '../custom_api/api';
import { Jumbo } from '../custom_components/components/jumbo';
export const fetchEventsOverviewJumboAanZet = async ()=>{
    const page = await getPage('/activiteiten', '');
    const result = page == 'error' || page == 'loading' ? fallback : {
        title: page.headerTitle,
        contents: page.description,
        imageUrl: page.imageUrl,
        imageUrlFallback: page.imageUrlFallback,
        imageUrlLarge: page.imageUrl,
        imageAlt: page.imageAlt,
        size: 'large',
        kind: 'activity-overview'
    };
    return {
        kind: 'result',
        value: result,
        status: 200
    };
};
const fallback = {
    title: 'Activiteiten',
    contents: 'Doe mee!',
    imageUrl: '',
    imageUrlFallback: '',
    imageUrlLarge: '',
    imageAlt: '',
    size: 'large',
    kind: 'activity-overview'
};
export const renderAanZetJumbo = (props)=>Jumbo({
        ...props,
        headerImageUrl: props.imageUrl,
        headerImageAlt: props.imageAlt,
        headerImageUrlFallback: props.imageUrlFallback,
        headerTitle: props.title
    });
